import { Job } from './Job'
import { loadAirExportJobRelated } from '@/api/AirExport/aeBooking'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import { batchCloneLcLJob, toInsure, updateQWCActual } from '@/api/AirExport/airExportJob'

import $store from '@/store'

export class AirExportJob extends Job {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'AirExportJob'
  }
  get airCargoDoc() {
    return this._data.airCargoDoc
  }
  set airCargoDoc(airCargoDoc) {
    this._data.airCargoDoc = airCargoDoc
  }

  get insure() {
    return this._data.insure
  }
  set insure(insure) {
    this._data.insure = insure === '' ? true : insure
  }

  get operateType() {
    return this._data.operateType
  }
  set operateType(operateType) {
    this._data.operateType = operateType || 0
  }
  get hawb() {
    return this._data.hawb
  }
  set hawb(hawb) {
    this._data.hawb = hawb || ''
  }
  get bookingTerm() {
    return this._data.bookingTerm
  }
  set bookingTerm(bookingTerm) {
    this._data.bookingTerm = bookingTerm || ''
  }
  get customClaim() {
    return this._data.customClaim
  }
  set customClaim(customClaim) {
    this._data.customClaim = customClaim || 0
  }
  get incoTerm() {
    return this._data.incoTerm
  }
  set incoTerm(incoTerm) {
    this._data.incoTerm = incoTerm || ''
  }
  get typeHawb() {
    return this._data.typeHawb
  }
  set typeHawb(typeHawb) {
    this._data.typeHawb = typeHawb || 0
  }
  get secondPortCode() {
    return this._data.secondPortCode
  }
  set secondPortCode(secondPortCode) {
    this._data.secondPortCode = secondPortCode || ''
  }
  get secondBookingAgentId() {
    return this._data.secondBookingAgentId
  }
  set secondBookingAgentId(secondBookingAgentId) {
    this._data.secondBookingAgentId = secondBookingAgentId || 0
  }
  get secondCarrierId() {
    return this._data.secondCarrierId
  }
  set secondCarrierId(secondCarrierId) {
    this._data.secondCarrierId = secondCarrierId || 0
  }
  get secondEtd() {
    return this._data.secondEtd
  }
  set secondEtd(secondEtd) {
    this._data.secondEtd = secondEtd
  }
  get secondAtd() {
    return this._data.secondAtd
  }
  set secondAtd(secondAtd) {
    this._data.secondAtd = secondAtd
  }
  get secondFlight() {
    return this._data.secondFlight
  }
  set secondFlight(secondFlight) {
    this._data.secondFlight = secondFlight || ''
  }
  get secondMawb() {
    return this._data.secondMawb
  }
  set secondMawb(secondMawb) {
    this._data.secondMawb = secondMawb || ''
  }
  get thirdCarrierId() {
    return this._data.thirdCarrierId
  }
  set thirdCarrierId(thirdCarrierId) {
    this._data.thirdCarrierId = thirdCarrierId || 0
  }
  get thirdETD() {
    return this._data.thirdETD
  }
  set thirdETD(thirdETD) {
    this._data.thirdETD = thirdETD
  }
  get thirdFlight() {
    return this._data.thirdFlight
  }
  set thirdFlight(thirdFlight) {
    this._data.thirdFlight = thirdFlight || ''
  }
  get thirdMawb() {
    return this._data.thirdMawb
  }
  set thirdMawb(thirdMawb) {
    this._data.thirdMawb = thirdMawb || ''
  }
  get thirdPortCode() {
    return this._data.thirdPortCode
  }
  set thirdPortCode(thirdPortCode) {
    this._data.thirdPortCode = thirdPortCode || ''
  }
  get comercialInspectation() {
    return this._data.comercialInspectation
  }
  set comercialInspectation(comercialInspectation) {
    this._data.comercialInspectation = comercialInspectation || false
  }
  get documentAll() {
    return this._data.documentAll
  }
  set documentAll(documentAll) {
    this._data.documentAll = documentAll || false
  }
  get cargoArrive() {
    return this._data.cargoArrive
  }
  set cargoArrive(cargoArrive) {
    this._data.cargoArrive = cargoArrive || false
  }
  get comercialInspectCheck() {
    return this._data.comercialInspectCheck
  }
  set comercialInspectCheck(comercialInspectCheck) {
    this._data.comercialInspectCheck = comercialInspectCheck || false
  }
  get InspectCheck() {
    return this._data.InspectCheck
  }
  set InspectCheck(InspectCheck) {
    this._data.InspectCheck = InspectCheck || false
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency || ''
  }
  get kcNo() {
    return this._data.kcNo
  }
  set kcNo(kcNo) {
    this._data.kcNo = kcNo || ''
  }
  get cabinReq() {
    return this._data.cabinReq
  }
  set cabinReq(cabinReq) {
    this._data.cabinReq = cabinReq || ''
  }
  get loadReq() {
    return this._data.loadReq
  }
  set loadReq(loadReq) {
    this._data.loadReq = loadReq || ''
  }
  get docReq() {
    return this._data.docReq
  }
  set docReq(docReq) {
    this._data.docReq = docReq || ''
  }
  get remarksShipping() {
    return this._data.remarksShipping
  }
  set remarksShipping(remarksShipping) {
    this._data.remarksShipping = remarksShipping || ''
  }
  get insideQuantity() {
    return this._data.insideQuantity
  }
  set insideQuantity(insideQuantity) {
    this._data.insideQuantity = insideQuantity || 0
  }
  get insidePacking() {
    return this._data.insidePacking
  }
  set insidePacking(insidePacking) {
    this._data.insidePacking = insidePacking || ''
  }
  get loadingAgentId() {
    return this._data.loadingAgentId
  }
  set loadingAgentId(loadingAgentId) {
    this._data.loadingAgentId = loadingAgentId || 0
  }
  get cargoProp() {
    return this._data.cargoProp
  }
  set cargoProp(cargoProp) {
    this._data.cargoProp = cargoProp || ''
  }
  get cWeight() {
    return this._data.cWeight
  }
  set cWeight(cWeight) {
    this._data.cWeight = cWeight || 0.0
  }
  get transfering() {
    return this._data.transfering
  }
  set transfering(transfering) {
    this._data.transfering = transfering || false
  }
  get loadingTerm() {
    return this._data.loadingTerm
  }
  set loadingTerm(loadingTerm) {
    this._data.loadingTerm = loadingTerm || ''
  }
  get customsClaim2() {
    return this._data.customsClaim2
  }
  set customsClaim2(customsClaim2) {
    this._data.customsClaim2 = customsClaim2 || 0
  }
  get quantityBooking() {
    return this._data.quantityBooking
  }
  set quantityBooking(quantityBooking) {
    this._data.quantityBooking = quantityBooking || 0
  }
  get weightBooking() {
    return this._data.weightBooking
  }
  set weightBooking(weightBooking) {
    this._data.weightBooking = weightBooking || 0.0
  }
  get cubageBooking() {
    return this._data.cubageBooking
  }
  set cubageBooking(cubageBooking) {
    this._data.cubageBooking = cubageBooking || 0.0
  }
  get chargeWeightBooking() {
    return this._data.chargeWeightBooking
  }
  set chargeWeightBooking(chargeWeightBooking) {
    this._data.chargeWeightBooking = chargeWeightBooking || 0.0
  }
  get csTotal() {
    return this._data.csTotal
  }
  set csTotal(csTotal) {
    this._data.csTotal = csTotal || 0
  }
  get csCounts() {
    return this._data.csCounts
  }
  set csCounts(csCounts) {
    this._data.csCounts = csCounts || 0
  }
  get checkCounts() {
    return this._data.checkCounts
  }
  set checkCounts(checkCounts) {
    this._data.checkCounts = checkCounts || 0
  }
  get ciCounts() {
    return this._data.ciCounts
  }
  set ciCounts(ciCounts) {
    this._data.ciCounts = ciCounts || 0
  }
  get shipment() {
    return this._data.shipment
  }
  set shipment(shipment) {
    this._data.shipment = shipment || false
  }
  get handOff() {
    return this._data.handOff
  }
  set handOff(handOff) {
    this._data.handOff = handOff || false
  }
  get bookingCompletion() {
    return this._data.bookingCompletion
  }
  set bookingCompletion(bookingCompletion) {
    this._data.bookingCompletion = bookingCompletion || false
  }
  get freightStationDimensions() {
    return this._data.freightStationDimensions
  }
  set freightStationDimensions(freightStationDimensions) {
    this._data.freightStationDimensions = freightStationDimensions
  }
  get dimensionsActual() {
    return this._data.dimensionsActual
  }
  set dimensionsActual(dimensionsActual) {
    this._data.dimensionsActual = dimensionsActual
  }
  get docDimensions() {
    return this._data.docDimensions
  }
  set docDimensions(docDimensions) {
    this._data.docDimensions = docDimensions
  }
  get commissionDimensions() {
    return this._data.commissionDimensions
  }
  set commissionDimensions(commissionDimensions) {
    this._data.commissionDimensions = commissionDimensions
  }
  get dimensionsSigning() {
    return this._data.dimensionsSigning
  }
  set dimensionsSigning(dimensionsSigning) {
    this._data.dimensionsSigning = dimensionsSigning
  }
  get pbProportion() {
    return this._data.pbProportion
  }
  set pbProportion(pbProportion) {
    this._data.pbProportion = pbProportion || 0.0
  }
  get pbProportion2() {
    return this._data.pbProportion2
  }
  set pbProportion2(pbProportion2) {
    this._data.pbProportion2 = pbProportion2 || 0.0
  }
  get siteRemark() {
    return this._data.siteRemark
  }
  set siteRemark(siteRemark) {
    this._data.siteRemark = siteRemark || ''
  }
  get selling() {
    return this._data.selling
  }
  set selling(selling) {
    this._data.selling = selling || ''
  }
  get buying() {
    return this._data.buying
  }
  set buying(buying) {
    this._data.buying = buying || ''
  }
  get sellingCurrency() {
    return this._data.sellingCurrency
  }
  set sellingCurrency(sellingCurrency) {
    this._data.sellingCurrency = sellingCurrency || ''
  }
  get buyingCurrency() {
    return this._data.buyingCurrency
  }
  set buyingCurrency(buyingCurrency) {
    this._data.buyingCurrency = buyingCurrency || ''
  }
  get sellPriceType() {
    return this._data.sellPriceType
  }
  set sellPriceType(sellPriceType) {
    this._data.sellPriceType = sellPriceType || ''
  }
  get buyPriceType() {
    return this._data.buyPriceType
  }
  set buyPriceType(buyPriceType) {
    this._data.buyPriceType = buyPriceType || ''
  }
  // CARGO-30582 13782上海奕然：所有业务类型中操作界面需增加海外客服和现场操作
  // get siteOpDepartment2() {
  //   return this._data.siteOpDepartment2
  // }
  // set siteOpDepartment2(siteOpDepartment2) {
  //   this._data.siteOpDepartment2 = siteOpDepartment2 || 0
  // }
  // get siteOP2() {
  //   return this._data.siteOP2
  // }
  // set siteOP2(siteOP2) {
  //   this._data.siteOP2 = siteOP2 || 0
  // }
  get sealCounts() {
    return this._data.sealCounts
  }
  set sealCounts(sealCounts) {
    this._data.sealCounts = sealCounts || 0
  }
  get authorizeCounts() {
    return this._data.authorizeCounts
  }
  set authorizeCounts(authorizeCounts) {
    this._data.authorizeCounts = authorizeCounts || 0
  }
  get patchUpCounts() {
    return this._data.patchUpCounts
  }
  set patchUpCounts(patchUpCounts) {
    this._data.patchUpCounts = patchUpCounts || 0
  }
  get ownWarehouse() {
    return this._data.ownWarehouse
  }
  set ownWarehouse(ownWarehouse) {
    this._data.ownWarehouse = ownWarehouse || false
  }
  get takePhotos() {
    return this._data.takePhotos
  }
  set takePhotos(takePhotos) {
    this._data.takePhotos = takePhotos || false
  }
  get documentsAttached() {
    return this._data.documentsAttached
  }
  set documentsAttached(documentsAttached) {
    this._data.documentsAttached = documentsAttached || false
  }
  get estimatedDateOfWarehousinge() { // 预计入库时间
    return this._data.estimatedDateOfWarehousinge
  }
  set estimatedDateOfWarehousinge(estimatedDateOfWarehousinge) {
    this._data.estimatedDateOfWarehousinge = estimatedDateOfWarehousinge
  }
  get estimatedDeliveryTime() { // 预计出库时间
    return this._data.estimatedDeliveryTime
  }
  set estimatedDeliveryTime(estimatedDeliveryTime) {
    this._data.estimatedDeliveryTime = estimatedDeliveryTime
  }
  get otherWarehouseNotes() {
    return this._data.otherWarehouseNotes
  }
  set otherWarehouseNotes(otherWarehouseNotes) {
    this._data.otherWarehouseNotes = otherWarehouseNotes || ''
  }
  get deliveryAgent() {
    return this._data.deliveryAgent
  }
  set deliveryAgent(deliveryAgent) {
    this._data.deliveryAgent = deliveryAgent || 0
  }
  get deliveryRemark() {
    return this._data.deliveryRemark
  }
  set deliveryRemark(deliveryRemark) {
    this._data.deliveryRemark = deliveryRemark || ''
  }
  get otherCharges() {
    return this._data.otherCharges
  }
  set otherCharges(otherCharges) {
    this._data.otherCharges = otherCharges || ''
  }
  get predictionOperation() {
    return this._data.predictionOperation
  }
  set predictionOperation(predictionOperation) {
    this._data.predictionOperation = predictionOperation || false
  }
  get printedLabel() {
    return this._data.printedLabel
  }
  set printedLabel(printedLabel) {
    this._data.printedLabel = printedLabel || false
  }
  get actualFlight() {
    return this._data.actualFlight
  }
  set actualFlight(actualFlight) {
    this._data.actualFlight = actualFlight || ''
  }
  get onwardJourney() {
    return this._data.onwardJourney
  }
  set onwardJourney(onwardJourney) {
    this._data.onwardJourney = onwardJourney || ''
  }
  get protocolType() {
    return this._data.protocolType
  }
  set protocolType(protocolType) {
    this._data.protocolType = protocolType || ''
  }
  get fileCutoff() {
    return this._data.fileCutoff
  }
  set fileCutoff(fileCutoff) {
    this._data.fileCutoff = fileCutoff
  }
  get subTenantId() {
    return this._data.subTenantId
  }
  set subTenantId(subTenantId) {
    this._data.subTenantId = subTenantId || 0
  }
  get airExportLoadingNotesUuid() {
    return this._data.airExportLoadingNotesUuid
  }
  set airExportLoadingNotesUuid(airExportLoadingNotesUuid) {
    this._data.airExportLoadingNotesUuid = airExportLoadingNotesUuid
  }
  get flightUuid() {
    return this._data.flightUuid
  }
  set flightUuid(flightUuid) {
    this._data.flightUuid = flightUuid
  }
  get airTransitRoutingDescriptionUuid() {
    return this._data.airTransitRoutingDescriptionUuid
  }
  set airTransitRoutingDescriptionUuid(airTransitRoutingDescriptionUuid) {
    this._data.airTransitRoutingDescriptionUuid = airTransitRoutingDescriptionUuid
  }
  get airExportFlightCustomerUuid() {
    return this._data.airExportFlightCustomerUuid
  }
  set airExportFlightCustomerUuid(airExportFlightCustomerUuid) {
    this._data.airExportFlightCustomerUuid = airExportFlightCustomerUuid
  }
  get densityContract() {
    return this._data.densityContract
  }
  set densityContract(densityContract) {
    this._data.densityContract = densityContract || 0
  }
  get densityActual() {
    return this._data.densityActual
  }
  set densityActual(densityActual) {
    this._data.densityActual = densityActual || 0
  }
  get densityBooking() {
    return this._data.densityBooking
  }
  set densityBooking(densityBooking) {
    this._data.densityBooking = densityBooking || 0
  }
  get densityDoc() {
    return this._data.densityDoc
  }
  set densityDoc(densityDoc) {
    this._data.densityDoc = densityDoc || 0
  }
  get warehouseInDate() { // 实际入库时间【数据库不存在】
    return this._data.warehouseInDate
  }
  set warehouseInDate(warehouseInDate) {
    this._data.warehouseInDate = warehouseInDate
  }
  get warehouseOutDate() { // 实际出库时间【数据库不存在】
    return this._data.warehouseOutDate
  }
  set warehouseOutDate(warehouseOutDate) {
    this._data.warehouseOutDate = warehouseOutDate
  }
  get estimatedDateOfWarehousingeDirty() { // 更改过预计入库时间【数据库不存在】
    return this._data.estimatedDateOfWarehousingeDirty
  }
  set estimatedDateOfWarehousingeDirty(estimatedDateOfWarehousingeDirty) {
    this._data.estimatedDateOfWarehousingeDirty = estimatedDateOfWarehousingeDirty || false
  }
  get estimatedDeliveryTimeDirty() { // 更改过预计出库时间【数据库不存在】
    return this._data.estimatedDeliveryTimeDirty
  }
  set estimatedDeliveryTimeDirty(estimatedDeliveryTimeDirty) {
    this._data.estimatedDeliveryTimeDirty = estimatedDeliveryTimeDirty || false
  }
  get bookingNo() { // 订舱编号
    return this._data.bookingNo
  }
  set bookingNo(bookingNo) {
    this._data.bookingNo = bookingNo
  }

  get quotationNum() { // 报价单号
    return this._data.quotationNum
  }
  set quotationNum(quotationNum) {
    this._data.quotationNum = quotationNum
  }

  get airport() { // 机场
    return this._data.airport
  }
  set airport(airport) {
    this._data.airport = airport
  }

  get actualEntryTime() { // 实际进场时间
    return this._data.actualEntryTime
  }
  set actualEntryTime(actualEntryTime) {
    this._data.actualEntryTime = actualEntryTime
  }

  get actualLoadingTime() { // 实际配载时间
    return this._data.actualLoadingTime
  }
  set actualLoadingTime(actualLoadingTime) {
    this._data.actualLoadingTime = actualLoadingTime
  }

  get estimatedDepartureTime() { // 预计起飞时间
    return this._data.estimatedDepartureTime
  }
  set estimatedDepartureTime(estimatedDepartureTime) {
    this._data.estimatedDepartureTime = estimatedDepartureTime
  }

  get actualDepartureTime() { // 实际起飞时间
    return this._data.actualDepartureTime
  }
  set actualDepartureTime(actualDepartureTime) {
    this._data.actualDepartureTime = actualDepartureTime
  }

  get actualReceivingTime() { // 实际收单时间
    return this._data.actualReceivingTime
  }
  set actualReceivingTime(actualReceivingTime) {
    this._data.actualReceivingTime = actualReceivingTime
  }

  get actualUnloadingTime() { // 实际卸货时间
    return this._data.actualUnloadingTime
  }
  set actualUnloadingTime(actualUnloadingTime) {
    this._data.actualUnloadingTime = actualUnloadingTime
  }

  get actualArrivalNotificationTime() { // 实际到货通知时间
    return this._data.actualArrivalNotificationTime
  }
  set actualArrivalNotificationTime(actualArrivalNotificationTime) {
    this._data.actualArrivalNotificationTime = actualArrivalNotificationTime
  }

  get actualPickupTime() { // 实际提货时间
    return this._data.actualPickupTime
  }
  set actualPickupTime(actualPickupTime) {
    this._data.actualPickupTime = actualPickupTime
  }

  get estimatedWarehouseDeliveryTime() { // 预计进仓交货时间
    return this._data.estimatedWarehouseDeliveryTime
  }
  set estimatedWarehouseDeliveryTime(estimatedWarehouseDeliveryTime) {
    this._data.estimatedWarehouseDeliveryTime = estimatedWarehouseDeliveryTime
  }

  get actualWarehouseDeliveryTime() { // 实际进仓交货时间
    return this._data.actualWarehouseDeliveryTime
  }
  set actualWarehouseDeliveryTime(actualWarehouseDeliveryTime) {
    this._data.actualWarehouseDeliveryTime = actualWarehouseDeliveryTime
  }

  get estimatedTimeOfDelivery() { // 预计送达时间
    return this._data.estimatedTimeOfDelivery
  }
  set estimatedTimeOfDelivery(estimatedTimeOfDelivery) {
    this._data.estimatedTimeOfDelivery = estimatedTimeOfDelivery
  }

  get actualDeliveryTime() { // 实际送达时间
    return this._data.actualDeliveryTime
  }
  set actualDeliveryTime(actualDeliveryTime) {
    this._data.actualDeliveryTime = actualDeliveryTime
  }

  get estimatedArrivalTime() { // 预计抵达时间
    return this._data.estimatedArrivalTime
  }
  set estimatedArrivalTime(estimatedArrivalTime) {
    this._data.estimatedArrivalTime = estimatedArrivalTime
  }

  get actualArrivalTime() { // 实际抵达时间
    return this._data.actualArrivalTime
  }
  set actualArrivalTime(actualArrivalTime) {
    this._data.actualArrivalTime = actualArrivalTime
  }

  get estimatedShippingTime() { // 预计送货时间
    return this._data.estimatedShippingTime
  }
  set estimatedShippingTime(estimatedShippingTime) {
    this._data.estimatedShippingTime = estimatedShippingTime
  }

  get actualShippingTime() { // 实际送货时间
    return this._data.actualShippingTime
  }
  set actualShippingTime(actualShippingTime) {
    this._data.actualShippingTime = actualShippingTime
  }

  get shippingAddress() { // 交单地址
    return this._data.shippingAddress
  }
  set shippingAddress(shippingAddress) {
    this._data.shippingAddress = shippingAddress
  }

  get shippingContactPerson() { // 交单联系人
    return this._data.shippingContactPerson
  }
  set shippingContactPerson(shippingContactPerson) {
    this._data.shippingContactPerson = shippingContactPerson
  }

  get shippingContactInfo() { // 交单联系方式
    return this._data.shippingContactInfo
  }
  set shippingContactInfo(shippingContactInfo) {
    this._data.shippingContactInfo = shippingContactInfo
  }

  get customerFileCutoff() { // 客户截单时间
    return this._data.customerFileCutoff
  }
  set customerFileCutoff(customerFileCutoff) {
    this._data.customerFileCutoff = customerFileCutoff
  }

  get customCutoff() { // 截关日期
    return this._data.customCutoff
  }
  set customCutoff(customCutoff) {
    this._data.customCutoff = customCutoff
  }

  get customerCutoff() { // 客户截关日期
    return this._data.customerCutoff
  }
  set customerCutoff(customerCutoff) {
    this._data.customerCutoff = customerCutoff
  }

  get customerShutout() { // 客户退关日期
    return this._data.customerShutout
  }
  set customerShutout(customerShutout) {
    this._data.customerShutout = customerShutout
  }

  get secondPol() { // 二程起运港
    return this._data.secondPol
  }
  set secondPol(secondPol) {
    this._data.secondPol = secondPol
  }

  get secondPod() { // 二程目的港
    return this._data.secondPod
  }
  set secondPod(secondPod) {
    this._data.secondPod = secondPod
  }

  get secondPolCode() { // 二程起运港代码
    return this._data.secondPolCode
  }
  set secondPolCode(secondPolCode) {
    this._data.secondPolCode = secondPolCode
  }

  get secondPodCode() { // 二程卸货港代码
    return this._data.secondPodCode
  }
  set secondPodCode(secondPodCode) {
    this._data.secondPodCode = secondPodCode
  }

  get estimatedTransferArrivalTime() { // 预计抵达中转时间
    return this._data.estimatedTransferArrivalTime
  }
  set estimatedTransferArrivalTime(estimatedTransferArrivalTime) {
    this._data.estimatedTransferArrivalTime = estimatedTransferArrivalTime
  }

  get transferArrivalTime() { // 抵达中转时间
    return this._data.transferArrivalTime
  }
  set transferArrivalTime(transferArrivalTime) {
    this._data.transferArrivalTime = transferArrivalTime
  }

  get estimatedTransferDepartureTime() { // 预计中转起飞时间
    return this._data.estimatedTransferDepartureTime
  }
  set estimatedTransferDepartureTime(estimatedTransferDepartureTime) {
    this._data.estimatedTransferDepartureTime = estimatedTransferDepartureTime
  }

  get transferDepartureTime() { // 中转起飞时间
    return this._data.transferDepartureTime
  }
  set transferDepartureTime(transferDepartureTime) {
    this._data.transferDepartureTime = transferDepartureTime
  }
  get secondAta() { // 二程ATA
    return this._data.secondAta
  }
  set secondAta(secondAta) {
    this._data.secondAta = secondAta
  }
  get purchasePriceLock() {
    return this._data.purchasePriceLock
  }
  set purchasePriceLock(purchasePriceLock) {
    this._data.purchasePriceLock = purchasePriceLock || false
  }
  get sellingPriceLock() {
    return this._data.sellingPriceLock
  }
  set sellingPriceLock(sellingPriceLock) {
    this._data.sellingPriceLock = sellingPriceLock || false
  }
  get thirdAta() { // 三程ATA
    return this._data.thirdAta
  }
  set thirdAta(thirdAta) {
    this._data.thirdAta = thirdAta
  }
  get thirdAtd() { // 三程ATD
    return this._data.thirdAtd
  }
  set thirdAtd(thirdAtd) {
    this._data.thirdAtd = thirdAtd
  }
  get slac() {
    return this._data.slac
  }
  set slac(slac) {
    this._data.slac = slac
  }
  set customerRemark(customerRemark) {
    this._data.customerRemark = customerRemark
  }

  get customerRemark() {
    return this._data.customerRemark
  }

  get specialOperationCode() {
    return this._data.specialOperationCode
  }

  set specialOperationCode(specialOperationCode) {
    this._data.specialOperationCode = specialOperationCode
  }

  get boardSales() {
    return this._data.boardSales
  }
  set boardSales(boardSales) {
    this._data.boardSales = boardSales
  }
  get boardCsr() {
    return this._data.boardCsr
  }
  set boardCsr(boardCsr) {
    this._data.boardCsr = boardCsr
  }
  get boardSite() {
    return this._data.boardSite
  }
  set boardSite(boardSite) {
    this._data.boardSite = boardSite
  }
  get arrivalMethod() {
    return this._data.arrivalMethod
  }
  set arrivalMethod(arrivalMethod) {
    this._data.arrivalMethod = arrivalMethod
  }
  get flightLabel() {
    return this._data.flightLabel
  }
  set flightLabel(flightLabel) {
    this._data.flightLabel = flightLabel
  }
  get serviceProduct() {
    return this._data.serviceProduct
  }
  set serviceProduct(serviceProduct) {
    this._data.serviceProduct = serviceProduct
  }
  get airlineProductUuid() {
    return this._data.airlineProductUuid
  }
  set airlineProductUuid(airlineProductUuid) {
    this._data.airlineProductUuid = airlineProductUuid
  }
  get appraisalCategory() {
    return this._data.appraisalCategory
  }
  set appraisalCategory(appraisalCategory) {
    this._data.appraisalCategory = appraisalCategory
  }
  get wood() {
    return this._data.wood
  }
  set wood(wood) {
    this._data.wood = wood
  }
  get hazardousGoodsOption() {
    return this._data.hazardousGoodsOption
  }
  set hazardousGoodsOption(hazardousGoodsOption) {
    this._data.hazardousGoodsOption = hazardousGoodsOption
  }
  get handlingInformation() {
    return this._data.handlingInformation
  }
  set handlingInformation(handlingInformation) {
    this._data.handlingInformation = handlingInformation
  }
  get frontEndWarehouseOperation() {
    return this._data.frontEndWarehouseOperation
  }
  set frontEndWarehouseOperation(frontEndWarehouseOperation) {
    this._data.frontEndWarehouseOperation = frontEndWarehouseOperation
  }
  get cargoTerminalOperation() {
    return this._data.cargoTerminalOperation
  }
  set cargoTerminalOperation(cargoTerminalOperation) {
    this._data.cargoTerminalOperation = cargoTerminalOperation
  }
  get estimatedDeliveryDate() {
    return this._data.estimatedDeliveryDate
  }
  set estimatedDeliveryDate(estimatedDeliveryDate) {
    this._data.estimatedDeliveryDate = estimatedDeliveryDate
  }

  get cubAgeContractImperial() {
    return this._data.cubAgeContractImperial
  }
  set cubAgeContractImperial(cubAgeContractImperial) {
    this._data.cubAgeContractImperial = cubAgeContractImperial || 0
  }

  get weightContractImperial() {
    return this._data.weightContractImperial
  }
  set weightContractImperial(weightContractImperial) {
    this._data.weightContractImperial = weightContractImperial || 0
  }

  get chargeWeightImperial() {
    return this._data.chargeWeightImperial
  }
  set chargeWeightImperial(chargeWeightImperial) {
    this._data.chargeWeightImperial = chargeWeightImperial || 0
  }

  get weightBookingImperial() {
    return this._data.weightBookingImperial
  }
  set weightBookingImperial(weightBookingImperial) {
    this._data.weightBookingImperial = weightBookingImperial || 0
  }

  get cubAgeBookingImperial() {
    return this._data.cubAgeBookingImperial
  }
  set cubAgeBookingImperial(cubAgeBookingImperial) {
    this._data.cubAgeBookingImperial = cubAgeBookingImperial || 0
  }

  get chargeWeightBookingImperial() {
    return this._data.chargeWeightBookingImperial
  }
  set chargeWeightBookingImperial(chargeWeightBookingImperial) {
    this._data.chargeWeightBookingImperial = chargeWeightBookingImperial || 0
  }

  get weightActualImperial() {
    return this._data.weightActualImperial
  }
  set weightActualImperial(weightActualImperial) {
    this._data.weightActualImperial = weightActualImperial || 0
  }

  get cubAgeActualImperial() {
    return this._data.cubAgeActualImperial
  }
  set cubAgeActualImperial(cubAgeActualImperial) {
    this._data.cubAgeActualImperial = cubAgeActualImperial || 0
  }

  get cWeightImperial() {
    return this._data.cWeightImperial
  }
  set cWeightImperial(cWeightImperial) {
    this._data.cWeightImperial = cWeightImperial || 0
  }

  get weightStationImperial() {
    return this._data.weightStationImperial
  }
  set weightStationImperial(weightStationImperial) {
    this._data.weightStationImperial = weightStationImperial || 0
  }

  get cubAgeStationImperial() {
    return this._data.cubAgeStationImperial
  }
  set cubAgeStationImperial(cubAgeStationImperial) {
    this._data.cubAgeStationImperial = cubAgeStationImperial || 0
  }

  get chargeWeightStationImperial() {
    return this._data.chargeWeightStationImperial
  }
  set chargeWeightStationImperial(chargeWeightStationImperial) {
    this._data.chargeWeightStationImperial = chargeWeightStationImperial || 0
  }

  get weightSigningImperial() {
    return this._data.weightSigningImperial
  }
  set weightSigningImperial(weightSigningImperial) {
    this._data.weightSigningImperial = weightSigningImperial || 0
  }

  get cubAgeSigningImperial() {
    return this._data.cubAgeSigningImperial
  }
  set cubAgeSigningImperial(cubAgeSigningImperial) {
    this._data.cubAgeSigningImperial = cubAgeSigningImperial || 0
  }

  get chargeWeightSigningImperial() {
    return this._data.chargeWeightSigningImperial
  }
  set chargeWeightSigningImperial(chargeWeightSigningImperial) {
    this._data.chargeWeightSigningImperial = chargeWeightSigningImperial || 0
  }

  get quantityStation() {
    return this._data.quantityStation
  }
  set quantityStation(quantityStation) {
    this._data.quantityStation = quantityStation || 0
  }
  get weightStation() {
    return this._data.weightStation
  }
  set weightStation(weightStation) {
    this._data.weightStation = weightStation || 0
  }
  get cubageStation() {
    return this._data.cubageStation
  }
  set cubageStation(cubageStation) {
    this._data.cubageStation = cubageStation || 0
  }
  get chargeWeightStation() {
    return this._data.chargeWeightStation
  }
  set chargeWeightStation(chargeWeightStation) {
    this._data.chargeWeightStation = chargeWeightStation || 0.0
  }
  get densityStation() {
    return this._data.densityStation
  }
  set densityStation(densityStation) {
    this._data.densityStation = densityStation || 0
  }
  get volumetricWeightStation() {
    return this._data.volumetricWeightStation
  }
  set volumetricWeightStation(volumetricWeightStation) {
    this._data.volumetricWeightStation = volumetricWeightStation || 0
  }
  get quantitySigning() {
    return this._data.quantitySigning
  }
  set quantitySigning(quantitySigning) {
    this._data.quantitySigning = quantitySigning || 0
  }
  get weightSigning() {
    return this._data.weightSigning
  }
  set weightSigning(weightSigning) {
    this._data.weightSigning = weightSigning || 0
  }
  get cubageSigning() {
    return this._data.cubageSigning
  }
  set cubageSigning(cubageSigning) {
    this._data.cubageSigning = cubageSigning || 0
  }
  get chargeWeightSigning() {
    return this._data.chargeWeightSigning
  }
  set chargeWeightSigning(chargeWeightSigning) {
    this._data.chargeWeightSigning = chargeWeightSigning || 0
  }
  get densitySigning() {
    return this._data.densitySigning
  }
  set densitySigning(densitySigning) {
    this._data.densitySigning = densitySigning || 0
  }
  get volumetricWeightSigning() {
    return this._data.volumetricWeightSigning
  }
  set volumetricWeightSigning(volumetricWeightSigning) {
    this._data.volumetricWeightSigning = volumetricWeightSigning || 0
  }
  get carrierWebsite() {
    return this._data.carrierWebsite
  }
  set carrierWebsite(carrierWebsite) {
    this._data.carrierWebsite = carrierWebsite
  }
  get agentInformation() {
    return this._data.agentInformation
  }
  set agentInformation(agentInformation) {
    this._data.agentInformation = agentInformation
  }
  // 锁定状态
  get lockStatus() {
    return this._data.lockStatus
  }
  set lockStatus(lockStatus) {
    this._data.lockStatus = lockStatus
  }
  async loadJobRelated(params) {
    params.jobUuid = params.jobUuid || this._data.uuid
    if (!params.jobUuid) {
      return
    }
    // 是否需要载入
    let needLoad = false
    // 将已经加载过的属性的标识置为false
    for (const key in params) {
      if (key === 'jobUuid') {
        continue
      }
      if (params[key] && typeof this._data[key] === 'object') {
        params[key] = false
      }
      if (params[key]) {
        needLoad = true
      }
    }
    if (!needLoad) {
      return
    }
    params.masterFlag = this._data.masterFlag
    await loadAirExportJobRelated(params).then(res => {
      const items = res.data
      if (items.job) {
        for (const key in items.job) {
          if (typeof this._data[key] === 'object') {
            continue
          }
          this._data[key] = items.job[key]
        }
      }
      for (const key in items) {
        if (key === 'job') {
          continue
        }
        this._data[key] = items[key] || null
      }
    })
  }

  async getAirCargoDoc() {
    const data = this._data
    if (typeof data.airCargoDoc !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'airCargoDoc': true })
      } else {
        if (data.cargoDoc) {
          data.airCargoDoc = data.cargoDoc
        } else {
          data.airCargoDoc = data.cargoDoc = []
        }
      }
    }
    return data.airCargoDoc
  }
  async getCargoDoc(type, create) {
    const airCargoDocs = await this.getAirCargoDoc()
    if (!airCargoDocs && !create) return null
    for (const doc of airCargoDocs) {
      if (doc.docType === type) {
        return doc
      }
    }
    if (!create) return null
    const cargoDoc = await new AirCargoDoc().newCargoDoc(this, type)
    cargoDoc.signByCarrier = ''
    cargoDoc.signByShipper = ''
    return cargoDoc
  }
  // 批量复制小票，组装数据返回给前台
  async batchCloneLcLJob() {
    return await batchCloneLcLJob({ jobUuid: this._data.uuid, branchId: $store.getters.currentOfficeId }).then(res => res.data)
  }

  async getLclMaster() {
    const data = this._data
    if (typeof data.lclMaster !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'lclMaster': true })
      }
    }
    return data.lclMaster
  }
  // 投保
  static async toInsure(seaCargoDoc, job, office) {
    return await toInsure({ seaCargoDoc, job, office }).then(res => res.data)
  }

  // 更新实际件毛体计费重量
  static async updateQWCActual(job) {
    return await updateQWCActual(job).then(res => res.data)
  }
}
